<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'first_time_login.label.title' | translate}}
</h2>
<mat-divider></mat-divider>
<div class="change-pass-notice">
  {{'first_time_login.label.notice' |translate}}
</div>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && changePassword()" [mustMatch]="['newPassword', 'confirmPassword']" appFocusFirstElement>
  <mat-dialog-content>
    <div class="row mt-2">
      <div class="col-12">
        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="clickVisibility()">
            <mat-icon>{{!newPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input #focusInput matInput [type]="newPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password' | translate"
                 name="newPassword" id="newPassword" [(ngModel)]="passwordData.newPassword" #newPass="ngModel" required
                 [pattern]="strengthPattern"
                 passwordPattern
                 (focus)="onFocus()"
                 (blur)="onBlur()"
                 minlength="8"
                 maxlength="100" (focusout)="passwordData.newPassword = passwordData.newPassword.trim()" autocomplete="off" />

          <!-- validate new password -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)" class="line-hint">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.pattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.pattern || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.pattern && !newPass?.errors?.required ? 'text-primary green-icon' : 'text-warn'">{{'change_password.validation.strength' | translate}}</span>
            </div>
          </mat-hint>
          <div></div>
          <!-- minlength=8 -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.minlength && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.minlength || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.minlength && !newPass?.errors?.required ?  'text-primary green-icon'  : 'text-warn'">{{'change_password.validation.at_least_8_letter' | translate}}</span>
            </div>
          </mat-hint>

          <!-- minlength=8 -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.invalidContainPattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.invalidContainPattern || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.invalidContainPattern && !newPass?.errors?.required ?  'text-primary green-icon' : 'text-warn'">{{'change_password.validation.not_contain' | translate}}</span>
            </div>
          </mat-hint>
        </mat-form-field>


      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="confirmPasswordVisibility = !confirmPasswordVisibility">
            <mat-icon>{{!confirmPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input matInput [type]="confirmPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password_confirm' | translate"
                 name="confirmPassword" id="confirmPassword" [(ngModel)]="passwordData.confirmPassword"
                 #confirmPass="ngModel" required maxlength="100" (focusout)="passwordData.confirmPassword = passwordData.confirmPassword.trim()" autocomplete="off"/>
          <mat-error *ngIf="confirmPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.confirm_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="confirmPass?.errors?.mustMatch">
            <span class="text-error">{{'change_password.validation.must_match' | translate}}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button mat-raised-button [disabled]="f.form.invalid" color="primary" type="submit" cdkFocusInitial>
      <mat-icon class="mr-0">check</mat-icon>{{'first_time_login.label.title' | translate}}
    </button>
  </mat-dialog-actions>
</form>
